<template>
  <v-app theme="shadow">
    <router-view />
    <v-snackbar
      v-model="snackbarVisible"
      :timeout="snackbarTimeout"
      :color="snackbarColor"
      location="bottom"
    >
      {{ snackbarText }}
    </v-snackbar>
  </v-app>
</template>

<script setup lang="ts">
import { useAnalytics } from '@/common/composables/useAnalytics'
import { useSnackbar } from '@/common/composables/useSnackbar'
import { useAuthStore } from '@/common/state/stores/authStore'
import { storeToRefs } from 'pinia'
import { onMounted, watchEffect } from 'vue'

const {
  visible: snackbarVisible,
  text: snackbarText,
  color: snackbarColor,
  timeout: snackbarTimeout
} = useSnackbar()

const authStore = useAuthStore()
const { isAuthenticated } = storeToRefs(authStore)

const defaultTitle = 'nocal - The most organized time of your life'
const loggedInTitle = 'nocal - Get Started'

watchEffect(() => {
  document.title = isAuthenticated.value ? loggedInTitle : defaultTitle
})

onMounted(() => {
  // Web analog of desktop's 'App Launched', fired once when the web app loads.
  useAnalytics().trackAppOpened({ reason: 'web_load' })
})
</script>
